export default __webpack_public_path__ + "static/media/le_neubourg7.865916f5.jpg";